import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}xml-stats/`,
  [],
  [authentication],
  [],
  false,
  60000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getSchedules() {
    return conduit.get('/schedules');
  },
  /**
   * @returns {AxiosPromise}
   */
  postSchedules(payload) {
    return conduit.post('/schedules', payload, [], []);
  },
  /**
   * @returns {AxiosPromise}
   */
  patchSchedule(payload) {
    const url = `/schedules/${payload.id}`;
    return conduit.patch(url, payload, [], []);
  },
  /**
   * @returns {AxiosPromise}
   */
  deleteSchedule(payload) {
    const url = `/schedules/${payload}`;
    return conduit.delete(url, [], []);
  },
  /**
   * @returns {AxiosPromise}
   */
  updateSchedules(payload) {
    const url = `/webservice/${payload}`;
    return conduit.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/services/xml-twenty-book.js